export interface PayBenchmarkingCompensationGraphViewVariantDetails {
  isPayBandValuesDisplayed: boolean;
  isHoverOnGraphEnabled: boolean;
}

export type PayBenchmarkingCompensationGraphViewVariant = 'Simple' | 'Details';

export const PayBenchmarkingCompensationGraphViewVariants: Record<
  PayBenchmarkingCompensationGraphViewVariant,
  PayBenchmarkingCompensationGraphViewVariantDetails
> = {
  Simple: {
    isPayBandValuesDisplayed: false,
    isHoverOnGraphEnabled: false,
  },
  Details: {
    isPayBandValuesDisplayed: true,
    isHoverOnGraphEnabled: true,
  },
};
